import { cn } from '@/lib/cn'

interface AvatarUser {
  email: string
  first_name?: string | null
  last_name?: string | null
}

type Size = 'sm' | 'md' | 'lg' | 'xl'

const sizeClasses: Record<Size, string> = {
  sm: 'h-8 w-8 text-[11px]',
  md: 'h-12 w-12 text-sm',
  lg: 'h-16 w-16 text-base',
  xl: 'h-20 w-20 text-lg',
}

function initialsOf(user: AvatarUser): string {
  const first = user.first_name?.[0]
  const last = user.last_name?.[0]
  const combined = [first, last].filter(Boolean).join('')
  if (combined) return combined.toUpperCase()
  return (user.email[0] ?? '?').toUpperCase()
}

interface Props {
  user: AvatarUser
  size?: Size
  className?: string
  gradient?: boolean
}

export function UserAvatar({ user, size = 'md', className, gradient = false }: Props) {
  return (
    <div
      className={cn(
        'flex shrink-0 select-none items-center justify-center rounded-full font-semibold',
        gradient
          ? 'bg-gradient-to-br from-foreground to-foreground/80 text-background shadow-sm'
          : 'bg-muted text-foreground',
        sizeClasses[size],
        className,
      )}
      aria-hidden="true"
    >
      {initialsOf(user)}
    </div>
  )
}
